<template lang="pug">
  button(
    class="resizer"
    :class="{ sm: small }"
    @mousedown="startResize"
  )
    e-svg-icon(:size="small ? 'xs' : 'md'") resizer
</template>

<script>
import ESvgIcon from '~/components/elements/icons/e-svg-icon'
import {
  FIELD_DEFAULT_HEIGHT,
  CHECKBOX_DEFAULT_SIZE,
  FIELD_MIN_WIDTH,
  NUMERIC_FIELD_DEFAULT_WIDTH,
  SWITCH_FIELD_DEFAULT_WIDTH,
  AUTOCOMPLETE_FIELD_DEFAULT_WIDTH
} from '~/modules/templates/constants/fields'

export default {
  name: 'TemplatesInputsResizer',
  components: {
    ESvgIcon
  },
  props: {
    field: {
      type: Object,
      required: true
    },
    element: {
      type: HTMLElement,
      required: true
    },
    isScalable: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isResizing: false,
      startX: 0,
      startY: 0,
      startWidth: 0,
      startHeight: 0
    }
  },
  computed: {
    minFieldDimensionSizes() {
      return {
        checkbox: {
          width: CHECKBOX_DEFAULT_SIZE,
          height: CHECKBOX_DEFAULT_SIZE
        },
        numeric: {
          width: NUMERIC_FIELD_DEFAULT_WIDTH,
          height: FIELD_DEFAULT_HEIGHT
        },
        switch: {
          width: SWITCH_FIELD_DEFAULT_WIDTH,
          height: FIELD_DEFAULT_HEIGHT
        },
        autocomplete: {
          width: AUTOCOMPLETE_FIELD_DEFAULT_WIDTH,
          height: FIELD_DEFAULT_HEIGHT
        }
      }
    }
  },
  watch: {
    isResizing(val) {
      this.$emit('resize', val)
    }
  },
  methods: {
    startResize(e) {
      this.isResizing = true
      this.startX = e.clientX
      this.startY = e.clientY
      this.startWidth = this.element.offsetWidth
      this.startHeight = this.element.offsetHeight

      window.addEventListener('mousemove', this.onResize)
      window.addEventListener('mouseup', this.stopResize)
    },
    onResize(e) {
      if (!this.isResizing) {
        return
      }
      const newWidth = this.startWidth + (e.clientX - this.startX)
      const newHeight = this.startHeight + (e.clientY - this.startY)
      const minValidFieldWidth =
        this.minFieldDimensionSizes[this.field.type]?.width ?? FIELD_MIN_WIDTH
      const minValidFieldHeight =
        this.minFieldDimensionSizes[this.field.type]?.height ?? FIELD_DEFAULT_HEIGHT
      const validWidth = newWidth >= minValidFieldWidth
      const validHeight = newHeight >= minValidFieldHeight
      if (validWidth && validHeight) {
        this.element.style.width = `${newWidth}px`
        if (this.isScalable) {
          this.element.style.minHeight = `${newHeight}px`
        } else {
          this.element.style.height = `${newHeight}px`
        }
        this.saveNewFieldDimensions(newWidth, newHeight)
      } else {
        this.stopResize()
      }
    },
    saveNewFieldDimensions(width, height) {
      this.$store.commit('templatefields/UPDATE_FIELD', {
        id: this.field.id,
        updatedData: {
          width,
          height,
          changed: true,
          changedSize: true
        }
      })
    },
    stopResize() {
      this.isResizing = false
      window.removeEventListener('mousemove', this.onResize)
      window.removeEventListener('mouseup', this.stopResize)
    }
  }
}
</script>

<style scoped lang="scss">
.resizer {
  width: 16px;
  height: 16px;

  display: flex;
  align-items: center;
  justify-content: center;

  cursor: se-resize;

  position: absolute;
  right: -1px;
  bottom: -1px;
  z-index: map-get($zIndexes, 'underFixed');

  &.sm {
    width: 12px;
    height: 12px;
    right: -2px;
    bottom: -2px;
  }
}
</style>
